import {useCallback, useLayoutEffect, useState} from '@wordpress/element'

export default function useDisclosure(defaultValue: boolean = false) {
  const [open, setOpen] = useState<boolean>(defaultValue)

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])
  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  return { open, handler: { open: handleOpen, close: handleClose }  }
}